import ApiError from '../../api/ApiError';

export function getCeDirectoryErrorCode(error: unknown): string | null {
  const candidate = error as Partial<ApiError> & {
    code?: unknown;
    body?: { error?: { code?: unknown }; code?: unknown };
  };
  const code = candidate?.body?.error?.code ?? candidate?.body?.code ?? candidate?.code;
  return typeof code === 'string' ? code : null;
}
